export const GET_DATA = 'GET_DATA'
export const GET_STATUS_CLOSED = 'GET_STATUS_CLOSED'
export const GET_STATUS_OPENED = 'GET_STATUS_OPENED'
export const GET_USER_ID = 'GET_USER_ID'
